// Convert a string of format dd-mm-yyyy to a Date object
function convertDate(dateString) {
  console.log("convertDate:", dateString);
  const date = new Date(dateString);
  console.log("🚀 ~ convertDate ~ date:", date)
  
  return date;
}


// Custom html countdown timer
class CountDownTimer extends HTMLElement {
  constructor() {
    super();
  }

  msToTime(duration) {
    //No reason to show negative time
    if (duration < 0) {
      return ["00", "00", "00", "00"];
    }

    var milliseconds = parseInt((duration % 1000) / 100),
      seconds = Math.floor((duration / 1000) % 60),
      minutes = Math.floor((duration / (1000 * 60)) % 60),
      hours = Math.floor((duration / (1000 * 60 * 60)) % 24),
      days = Math.floor(duration / (1000 * 60 * 60 * 24));

    days = days < 10 ? "0" + days : days;
    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    return [days, hours, minutes, seconds];
  }

  get_time_remaining() {
    var now = new Date().getTime();
    var countDownDate = convertDate(this.getAttribute("expiredate")).getTime();
    var distance = countDownDate - now;
    return this.msToTime(distance);
  }

  set_countdown() {
    var time_remaining = this.get_time_remaining();
    if (this.days) this.days.innerHTML = time_remaining[0];
    this.hour.innerHTML = time_remaining[1];
    this.minutes.innerHTML = time_remaining[2];
    this.seconds.innerHTML = time_remaining[3];
  }

  connectedCallback() {
    this.days = this.querySelector(".counter-days");
    this.hour = this.querySelector(".counter-hours");
    this.minutes = this.querySelector(".counter-minutes");
    this.seconds = this.querySelector(".counter-seconds");
    
    // Set initial countdown immediately
    this.set_countdown();
    
    // Then update every second
    setInterval(this.set_countdown.bind(this), 1000);
  }
}

customElements.define("countdown-timer", CountDownTimer);

// console.log("countdown-timer defined")

